// usePaddle.js
import { useState, useEffect } from 'react';
import { initializePaddle } from '@paddle/paddle-js';
import { PaddleBearer, PaddleToken } from '../assets/constants/PaddleStrings';

export const usePaddle = (
  eventCallbackFunction,
  redirectIfSuccess = false,
  isUpdateSubscription = false
) => {
  const [paddle, setPaddle] = useState(null);

  useEffect(() => {
    initializePaddle({
      environment: 'sandbox',
      token: PaddleToken,
      pwAuth: PaddleBearer,
      eventCallback: eventCallbackFunction,
      // function (data) {
      //   if (data.name === 'checkout.completed') {
      //     eventCallbackFunction(data);
      //     closeCheckout();
      //   }
      // },
    }).then((paddleInstance) => {
      if (paddleInstance) {
        setPaddle(paddleInstance);
      }
    });
  }, [eventCallbackFunction]);

  const closeCheckout = () => {
    paddle?.Checkout.close();
  };

  const openCheckout = (itemsList, transactionId) => {
    // console.log(paddle);

    let data = {
      settings: {
        displayMode: 'overlay',
        theme: 'light',
        locale: 'en',
        allowedPaymentMethods: ['card'],
        successUrl: redirectIfSuccess
          ? isUpdateSubscription
            ? 'http://localhost:3000/app/my-account/membership-info'
            : 'http://localhost:3000/app/'
          : null,
      },
    };

    if (transactionId) {
      data = {
        ...data,
        transactionId: transactionId,
      };
    } else {
      data = {
        ...data,
        items: itemsList,
      };
    }

    paddle?.Checkout.open(data);
  };

  return { paddle, openCheckout, closeCheckout };
};

// how to use this hook Example:

// import React from 'react';
// import { usePaddle } from './usePaddle';

// export function Checkout() {
//   const { openCheckout } = usePaddle();

//   const handleOpenCheckout = () => {
//     const itemsList = [
//       {
//         priceId: 'pri_01hftt7wbf42v5rgdnxb10dh51',
//         quantity: 100,
//       },
//     ];

//     openCheckout(itemsList);
//   };

//   return (
//     <div>
//       <button onClick={handleOpenCheckout}>Open Checkout</button>
//     </div>
//   );
// }
